<template>
  <div class="page-course-list" v-show="showAll">
    <div class="left-right-content clearfix">
      <div class="c-left">
        <div class="paeparation">
          <div class="search">
            <el-input class="ipt" clearable size="large" v-model="courseParam.courseName" placeholder="请输入课程名称"></el-input>
            <div class="btn" @click="changePage(1)">
              <i class="el-icon-search" ></i> 搜索
            </div>
          </div>
          <div class="types-list">
            <div class="type-item clearfix" v-show="showType">
              <div class="tit">课程形式：</div>
              <ul class="cases clearfix">
                <li :class="{ active: courseParam.classificationOf==null }" @click="classificationOfType(0)">全部</li>
                <li :class="{ active: courseParam.classificationOf==14 }"  @click="classificationOfType(14)">直播</li>
                <li :class="{ active: courseParam.classificationOf==13 }"  @click="classificationOfType(13)">点播</li>
              </ul>
            </div>

            <div class="type-item clearfix" v-show="showType">
              <div class="tit">课程分类：</div>
              <ul class="cases clearfix">
                <li :class="{ active: courseParam.courseLevel==null }" @click="selectLevel(-1)">全部</li>
                <li v-for="(item, index) in shenduList" :key="index" :class="{ active: courseParam.courseLevel==item.id }" @click="selectLevel(item.id)">{{ item.val }}</li>
              </ul>
            </div>

            <div class="type-item clearfix" v-show="showType">
              <div class="tit">课程类型：</div>
              <ul class="cases clearfix">
                <li :class="{ active: courseParam.animationCourseType==null }" @click="selectType(0)">全部</li>

                <li v-for="(item, index) in contTabs" :key="index" :class="{ active: courseParam.animationCourseType==item.id }" @click="selectType(item.id)">{{ item.tag }}</li>
              </ul>
            </div>

          </div>
        </div>
        <div class="paeparation-result clearfix" v-if="newIndexCourseList.total>0" v-show="isMounted" >
          <div class="work-card-one" v-for="(item, index) in newIndexCourseList.list" :key="index">

            <a :href="baseUrl+'/livedetail?id='+item.liveId+'&plate='+item.belongSection" target="_blank"  class="img-f" v-if="item.classificationOf == 14">
              <img :src="item.courseThumbnail" :alt="item.courseThumbnail">
<!--              <div class="c-type" >直播</div>-->
              <div class="living" v-if="item.showStatus==2"><i class="el-icon-s-data"></i> 直播中</div>
            </a>

            <a :href="item.courseSeries == 0 ?baseUrl+'/videodetail?plate='+item.belongSection+'&id='+item.id:baseUrl+'/videoduo?plate='+item.belongSection+'&id='+item.id" target="_blank" class="img-f" v-else>
              <img :src="item.courseThumbnail" :alt="item.courseThumbnail">
<!--              <div class="c-type" >点播</div>-->
            </a>

            <div class="card-infoes has-price">
<!--                @click.native="eventWa('视频详情页面', '点击', item.courseName,item.id )"-->
                <div class="course-tit">
                <a :href="baseUrl+'/livedetail?id='+item.liveId+'&plate='+item.belongSection" target="_blank" v-if="item.classificationOf == 14" :title="item.courseName">{{item.courseName}}</a>
                <a :href="item.courseSeries == 0 ?baseUrl+'/videodetail?plate='+item.belongSection+'&id='+item.id:baseUrl+'/videoduo?plate='+item.belongSection+'&id='+item.id" target="_blank" v-else :title="item.courseName" >{{item.courseName}}</a>
              </div>
              <div class="price-author clearfix">
                <div class="c-price">
                  <div v-if="item.promotionStartTimeStr >new Date().getTime() && item.promotionEndTimeStr < new Date().getTime() ">
                      <span v-if=" item.promotionPrice > 0 ">￥{{item.promotionPrice}}</span><span v-else>免费</span><span class="old-price">￥{{item.coursePrice}}</span>
                  </div>
                  <div v-else>
                    <div class="c-price"><span v-if=" item.coursePrice > 0 ">￥{{item.coursePrice}}</span><span v-else>免费</span></div>
                  </div>
                </div>
                <a :href="baseUrl+'/home?userId='+item.creatorId"  target="_blank" class="author">{{item.creatorName}}</a>
              </div>
            </div>
          </div>

        </div>

        <div v-else class="common-no-data">
          <img class="img" :src="emptyImg" alt="">
          <!--                    <span class="words">抱歉！您访问的页面暂无数据</span>-->
        </div>
        <div class="pagintion-f" v-if="isMounted && newIndexCourseList.total>0" v-show="isMounted" >
          <el-pagination
                  background
                  @current-change="changePage"
                  layout="prev, pager, next,jumper"
                  :current-page="courseParam.pageIndex"
                  :page-size="courseParam.pageSize"
                  :total="newIndexCourseList.total"
                  :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
      </div>
      <div class="c-right">
<!--        <div class="one-item">-->
<!--          <div class="one-title">-->
<!--            热门直播-->
<!--            <i class="el-icon-refresh-right shuaxin" @click="hotLive()"></i>-->
<!--          </div>-->
<!--          <div class="works-list">-->
<!--            <router-link :to="'/livedetail?id='+item.liveId" target="_blank" class="item"  v-for="(item, index) in hotLiveList" :key="index">-->
<!--              <div class="work-img-f">-->
<!--                <img :src="item.courseThumbnail" alt="">-->
<!--                <div class="mask"><i class="el-icon-video-play play-icon"></i></div>-->
<!--              </div>-->
<!--              <div class="work-title">{{item.courseName}}</div>-->
<!--              <div class="price-author clearfix">-->
<!--                <div class="c-price">-->
<!--                  <div v-if="item.promotionStartTime">-->
<!--                    {{item.promotionPrice}}<span class="old-price">￥{{item.coursePrice}}</span>-->
<!--                  </div>-->
<!--                  <div v-else>-->
<!--                    <div class="c-price">￥{{item.coursePrice}}</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <router-link :to="'/home?userId=' + item.creatorId" target="_blank" class="author">{{item.creatorName}}</router-link>-->
<!--              </div>-->
<!--            </router-link>-->

<!--          </div>-->
<!--        </div>-->
        <div class="one-item">
          <div class="one-title">
<!--            热门点播-->
            热门课程
            <i class="el-icon-refresh-right shuaxin" @click="hotVideo()"></i>
          </div>
          <div class="works-list">
              <div v-for="(item, index) in hotVideoList" :key="index">
                  <router-link :to=" item.courseSeries == 0 ?'/videodetail?id='+item.id+'&plate='+item.belongSection: '/videoduo?id='+item.id+'&plate='+item.belongSection" target="_blank" class="item" :title="item.courseName" >
<!--                  <router-link :to="'/videodeduo?id='+item.id" v-else target="_blank" class="item" >-->
                      <div class="work-img-f">
                          <img :src="item.courseThumbnail" alt="">
                          <div class="mask"><i class="el-icon-video-play play-icon"></i></div>
                      </div>
                      <div class="work-title">{{item.courseName}}</div>
                      <div class="price-author clearfix">
                          <div class="c-price">
                              <div v-if="item.promotionStartTime">
                                  <span v-if=" item.promotionPrice > 0 ">￥{{item.promotionPrice}}</span><span v-else>免费</span><span class="old-price">￥{{item.coursePrice}}</span>
                              </div>
                              <div v-else>
                                  <div class="c-price"><span v-if=" item.coursePrice > 0 ">￥{{item.coursePrice}}</span><span v-else>免费</span></div>
                              </div>
                          </div>
                          <router-link :to="'/home?userId=' + item.creatorId" target="_blank" class="author">{{item.creatorName}}</router-link>
                      </div>
                  </router-link>
              </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import updateTdk from "@/utils/tdk";

  import courseApi from '@/api/course'
  import tagApi from '@/api/tags'
  import { mapState } from 'vuex'

export default {
  components: {

  },
    computed: {
        ...mapState(['newIndexCourseList'])
    },
  data () {
    return {
      baseUrl:process.env.config.RRDH_HOST,
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render
        shenduVal: 0,
        shenduIndex: 0,
        shenduList: [
        {
            id: 0,
            val: '基础课程'
        },
        {
            id: 1,
            val: '高级课程'
        },
        {
            id: 2,
            val: '认证课程'
        },
        {
            id: 3,
            val: '制作技巧'
        }
        ],
      tagParam:{
        parentId:-3,

      },
        showAll:false,
      contTabs: null,
      contTabIndex: 0,
      courseParam:{
        courseName:'',
        classificationOf:null, //当前需求 ，默认显示点播课
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 12,
        belongSection:2, //默认传统文化板块
        animationCourseType:null,//作品类型
        courseLevel:null,
      },
      hotLiveParam:{
        courseName:'',
        classificationOf:14,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 2,
        order:'hot',
        //belongSection:2, //默认传统文化板块
        animationCourseType:null,//作品类型
      },
      hotCourseParam:{
        courseName:'',
        classificationOf:13,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 5,
        order:'hot',
        //belongSection:2, //默认传统文化板块
        animationCourseType:null,//作品类型
      },
      hotLiveList:[],
      hotLiveTotal:0,
      hotVideoList:[],
      hotCourseTotal:0,
      courseData:[],//列表数据
      total:0,
      searchIpt: '',
      emptyImg: require('@/assets/images/empty.png'),
      plate:'',
        showType:false,
    }
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com/course">`
    };
  },
  serverPrefetch() {
    // this.setSeo();
    // updateTdk.call(this);
      this.fetchData()
      return this.initData();
  },
    // beforeRouteUpdate(to, from, next) {
    //     // 一般建议路由变更采用计算属性或者store直接绑定
    //     // 特殊情况处理可以采用如下方案 重新注册数据返回处理
    //     this.initData()
    //     next();
    // },
  mounted() {
    this.isMounted = true
      this.fetchData()
      this.initData().then(()=>{
          this.fetchDataMounted()
      })

    //thiss.hotLive() //暂时不显示直播相关内容 6.20

  },
  methods:{
    setSeo() {
      this.headTitle = "动画课程——人人动画网【官网】";
      this.headKeywords = "iClone,CTA,iCloneCC,ct8,headshot";
      this.headDesc = "想学快速动画技术，就上人人动画网，这里的每一门课程都有十分清晰的使用场景，它能真正的把老师的知识变成自己的知识";
    },
    fetchData(){
        let plate = this.$route.query.plate
        this.plate = plate
        if(plate && plate == '2'){
            this.courseParam.classificationOf = 14
            this.tagParam.parentId = -4
        }else {
            this.showType = true
            this.tagParam.parentId = -3
        }

        if(plate){
            this.courseParam.belongSection = plate
            this.hotLiveParam.belongSection = plate
            this.hotCourseParam.belongSection = plate
        }


        let paramPageIndex = this.$route.query.toPageNum
        let classType = this.$route.query.classType
        let cName = this.$route.query.cName
        let animationType = this.$route.query.animationType
        let cLevel = this.$route.query.cLevel
        if(!paramPageIndex){
            paramPageIndex = 1
        }
        this.courseParam.pageIndex =Number(paramPageIndex)
        if(classType){
            if(classType == 0){
                this.courseParam.classificationOf = null
            }else{
                this.courseParam.classificationOf = classType
            }
        }
        if(cName){
            this.courseParam.courseName = cName
        }
        if(animationType){
            if(animationType == 0){
                this.courseParam.animationCourseType = null
            }else{
                this.courseParam.animationCourseType = animationType
            }
        }
        if(cLevel){
            if(cLevel == -1){
                this.courseParam.courseLevel = null
            }else{
                this.courseParam.courseLevel = cLevel
            }
        }
    },
    fetchDataMounted(){
        setTimeout(()=>{
            this.isMounted = true;
            tagApi.getList(this.tagParam).then(reTag => {
                this.contTabs=reTag.response
                //this.search(1)
                this.hotVideo()
                this.showAll = true
            })
        },1000)
    },
    initData(){
      this.$loading(true)
      const cookies = this.$ssrContext && this.$ssrContext.cookies
      return this.$store.dispatch("FETCH_NEW_INDEX_COURSE_LIST", {params: this.courseParam,cookies:cookies}).finally(() => {
          this.$loading(false)
          this.setSeo();
          updateTdk.call(this);
      })
    },
    search(page){
      let thiss = this
      thiss.courseParam.pageIndex = page

      courseApi.getPage(thiss.courseParam).then(reCourse => {
        thiss.courseData = reCourse.list
        thiss.total = reCourse.total
        thiss.courseParam.pageIndex = reCourse.pageNum
      })

    },

    changePage(page){
      let urlNow=window.location.href
      if(urlNow.indexOf("toPageNum") > 0){
          urlNow = urlNow.substr(0,urlNow.indexOf("&toPageNum="))
      }
      let url = urlNow+"&toPageNum="+page

      if(this.courseParam.classificationOf){
          url += "&classType="+this.courseParam.classificationOf
      }
      if(this.courseParam.courseName){
          url += "&cName="+this.courseParam.courseName
      }
      if(this.courseParam.animationCourseType){
          url += "&animationType="+this.courseParam.animationCourseType
      }
      if(this.courseParam.courseLevel != null){
          url += "&cLevel="+this.courseParam.courseLevel
      }
      window.location.href= url

    },

    hotLive(){
      let thiss = this
      courseApi.getPage(thiss.hotLiveParam).then(data => {

        thiss.hotLiveList=data.list;

        thiss.hotLiveTotal = data.total
        if(thiss.hotLiveParam.pageIndex == Math.ceil(thiss.hotLiveTotal/thiss.hotLiveParam.pageSize)){
          thiss.hotLiveParam.pageIndex =1
        }else{
          thiss.hotLiveParam.pageIndex = thiss.hotLiveParam.pageIndex +1
        }
      })
    },
    hotVideo(){
      let thiss = this
      courseApi.getPage(thiss.hotCourseParam).then(data => {

        thiss.hotVideoList=data.list;

        thiss.hotCourseTotal = data.total
        if(thiss.hotCourseParam.pageIndex == Math.ceil(thiss.hotCourseTotal/thiss.hotCourseParam.pageSize)){
          thiss.hotCourseParam.pageIndex =1
        }else{
          thiss.hotCourseParam.pageIndex = thiss.hotCourseParam.pageIndex +1
        }
      })
    },
    classificationOfType(type){
      if(type == 0){
        this.courseParam.classificationOf = null
      }else{
        this.courseParam.classificationOf = type
      }
        //this.search(1)
      this.changePage(1)
    },
    //选择作品类型
    selectType (id) {
      if(id == 0){
        this.courseParam.animationCourseType = null
      }else{
        this.courseParam.animationCourseType = id
      }
        //this.search(1)
        this.changePage(1)
    },
      //选择课程分类
      selectLevel (id) {
          if(id == -1){
              this.courseParam.courseLevel = null
          }else{
              this.courseParam.courseLevel = id
          }
          //this.search(1)
          this.changePage(1)
      },
      //自定义事件
      eventWa(category, action, opt_label, opt_value){
          waTag('event',category, action, opt_label, opt_value)
      }

  }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
.page-course-list{
  padding-top: @NAVHEIGHT;
  .left-right-content{
    margin-top: 30px;
  }
  .paeparation{
    margin-top: 0;
    margin-bottom: 0;
  }
  .paeparation-result{
    padding-top: 20px;
    background: #f6f6f6;
  }
}
@media (min-width: 751px) and (max-width: 1023px) {
  .work-card-one{
    margin-left: 28px;
    width: 400px;
  }
}
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
</style>
